<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card">
            <div class="card-body">
                <div class="card-title">
                    <div class="row">
                        <!--Messaggio con rapportino + utente + stato-->
                        <div class="col-12 d-flex align-items-center p-1">
                            <h3 class="m-0" [ngClass.md]="'mr-1'">{{"WORKDAY_REPORT_OF" | translate}} {{currentMonthAndYear}}</h3>
                            <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-secondary ml-1"
                                  *ngIf="!previousReports">{{"STATUS.NOT_SAVED" | translate}}</span>
                            <div [ngClass.xl]="'ml-1'" *ngIf="previousReports">
                            <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-success"
                                  *ngIf="previousReports && previousReports.status===2">{{"APPROVED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-info mr-1"
                                      *ngIf="previousReports && previousReports.status===0">{{"STATUS.SAVED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-secondary"
                                      *ngIf="previousReports && previousReports.status===0">{{"NOT_SENDED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-danger"
                                      *ngIf="previousReports && previousReports.status===3">{{"REJECTED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-warning"
                                      *ngIf="previousReports && previousReports.status===1">{{"PENDING" | translate}}</span>
                            </div>
                        </div>
                        <!--Messaggio per il l'invio del rapportino-->
                        <div class="col-12">
                            <div *ngIf="!lockReport && (statusReport === -1 || statusReport === 0)"
                                 class="font-small-4">{{"NOW_YOU_CAN_SEND_REPORT" | translate}}</div>
                        </div>
                        <div class="col-12">
                            <div *ngIf="lockReport && (statusReport === -1 || statusReport === 0)" class="font-small-4">{{"UNLOCK_WORKDAY_REPORT_LABEL" | translate}}
                                <span class="text-danger">{{ this.unlockStaffDate && this.unlockStaffDate.length > 0 ? this.unlockStaffDate : _utilService.formatDate(unlockDay, 'DD MMMM.')}}</span>
                            </div>
                        </div>
                        <!--Nota rifiuto-->
                        <div class="col-12">
                            <div *ngIf="previousReports && previousReports.status_note && previousReports.status_note.length > 0 && previousReports.status === 3">
                                <p class="font-small-3 mb-0 pb-0">{{"MOTIVATION" | translate}}:</p>
                                <p class="font-small-4">{{previousReports.status_note}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!_utilService.isMobile && !_utilService.isTablet">
                    <div class="col-xl-3 col-12">
                        <h4>{{"DAYS" | translate | titlecase}}</h4>
                    </div>
                    <div class="col-xl-2 col-12">
                        <h4>{{"WORKED_HOURS" | translate}}</h4>
                    </div>
                </div>
                <div class="row align-items-center border p-1" *ngFor="let day of daysOfTheMonth"
                     [ngClass]="isWorkDay(day) ? (_utilService.isHoliday(day) ? 'day-holiday' : 'day-work') : 'day-off'">
                    <!--Giorni-->
                    <div class="col-xl-3 col-12">
                        {{_utilService.formatDate(day, 'dddd DD') | titlecase}}
                    </div>
                    <!--Ore lavorata-->
                    <div class="col-xl-1 col-12 mt-1 mt-md-0" *ngIf="statusReport !== 2 && statusReport !== 1">
                        <input type="number" class="form-control" [max]="24" [(ngModel)]="newReport.days[day].working_hours" (change)="calculateTotalWorkedHours($any($event).target.value, day)">
                    </div>
                    <div class="col-xl-2 col-12 mt-1 mt-md-0" *ngIf="statusReport === 2 || statusReport === 1">
                        <span *ngIf="_utilService.isMobile || _utilService.isTablet">{{"HOURS" | translate | titlecase}}</span>  {{newReport.days[day].working_hours}}h
                    </div>
                </div>
                <div class="card-footer px-0">
                    <!--Conteggio ore totali -->
                    <div class="row justify-content-start align-items-start mb-1">
                        <div class="col-xl-2 col-12">
                            <label for="totalWorkedHours">{{"WORKED_HOURS" | translate}}:</label>
                            <div id="totalWorkedHours">{{totalWorkedHours}}h</div>
                        </div>
                    </div>
                    <div class="row">
                        <!--Tasti visualizzabili soltanto dall'utente-->
                        <div class="col-12">
                            <!--Messaggio invio report dal -->
                            <div *ngIf="(statusReport === -1 || statusReport === 0)  && lockReport"
                                 class="font-weight-bolder d-flex justify-content-end mb-075">
                                {{"REPORT_AVAILABLE_FROM" | translate}}&nbsp;<span
                                    class="text-danger">{{ this.unlockStaffDate && this.unlockStaffDate.length > 0 ? this.unlockStaffDate : _utilService.formatDate(unlockDay, 'DD MMMM')}}</span>
                            </div>
                            <!--Bottoni salva aggiorna e invia report -->
                            <div class="d-flex justify-content-end">
                                <button class="btn btn-outline-primary mr-1" (click)="saveReport()"
                                        *ngIf="!previousReports">{{"SAVE" | translate}}</button>
                                <button class="btn btn-outline-primary mr-1" (click)="updateReport()"
                                        *ngIf="previousReports && (previousReports.status === 0 || previousReports.status === 3)">{{"UPDATE" | translate}}</button>
                                <button class="btn btn-primary" *ngIf="!lockReport && (previousReports && previousReports.status === 0)"
                                        (click)="sendReport()">{{"SEND_REPORT" | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
